var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAnalyticsMenu = function SvgAnalyticsMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    stroke: "#212121",
    strokeWidth: 1.2,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.369,
    cy: 18.594,
    rx: 2.369,
    ry: 2.406
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.316,
    cy: 8.226,
    rx: 2.369,
    ry: 2.406
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.477,
    cy: 16.189,
    rx: 2.369,
    ry: 2.406
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 21.631,
    cy: 2.406,
    rx: 2.369,
    ry: 2.406
  }), /*#__PURE__*/React.createElement("path", {
    d: "m7.987 10.218-4.285 6.387m16.712-12.14-5.717 9.665m-2.33-.069-1.938-3.706"
  }))));
};
export default SvgAnalyticsMenu;